import { ButtonBase, Grid, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useResponsive } from "../../../../Modulo_Responsive/Hooks/useResponsive";

const Formulario_Contactenos = () => {
    const { sCell } = useResponsive();
    const [form, setForm] = useState({
        nombre: "",
        correo: "",
        telefono: "",
        ciudad: "",
        mensaje: "",
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = () => {
        console.log(form);
        // Aquí puedes agregar la lógica de envío
    };

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12 }}
            sx={{}}
            component="section"
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                size={{ xs: 12, sm: 12, md: 10 }}
                sx={{ maxWidth: '700px', px: 4, background: "#F5F6F7", py:4 }}
            >
                {/* Título */}
                <Grid container justifyContent="flex-start" size={{ xs: 12 }} sx={{ mb: 4 }}>
                    <Typography
                        component="h2"
                        variant="h2"
                        sx={{fontWeight: 800, fontSize: 30, color: '#223B59'}}
                    >
                        Contáctenos
                    </Typography>
                </Grid>

                {/* Descripción */}
                <Grid container size={{ xs: 12 }} sx={{ mb: 4 }}>
                    <Typography
                        component="p"
                        variant="body1"
                        sx={{}}
                    >
                        En Espacio Compacto ejecutamos soluciones técnicas con respaldo real.
                        Solicite diagnóstico técnico y evite sobrecostos futuros.
                    </Typography>
                </Grid>

                {/* Formulario */}
                <Grid container size={{ xs: 12, sm: 12, md: 12 }} direction="column" gap={0}>

                    <TextField
                        name="nombre"
                        placeholder="Nombre y Apellidos"
                        value={form.nombre}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        sx={inputStyle}
                    />

                    <TextField
                        name="correo"
                        placeholder="Correo Electrónico"
                        value={form.correo}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        sx={inputStyle}
                    />

                    <TextField
                        name="telefono"
                        placeholder="Teléfono o Celular"
                        value={form.telefono}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        sx={inputStyle}
                    />

                    <TextField
                        name="ciudad"
                        placeholder="Ciudad"
                        value={form.ciudad}
                        onChange={handleChange}
                        fullWidth
                        variant="outlined"
                        sx={inputStyle}
                    />

                    <TextField
                        name="mensaje"
                        placeholder="Cuéntanos sobre tu proyecto, pronto un asesor se comunicara contigo..."
                        value={form.mensaje}
                        onChange={handleChange}
                        fullWidth
                        multiline
                        rows={5}
                        variant="outlined"
                        sx={{
                            ...inputStyle,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 0,
                                alignItems: 'flex-start',
                            }
                        }}
                    />

                    {/* Botón */}
                    <Grid container justifyContent="flex-start" size={{ xs: 12 }}>
                        <ButtonBase
                            onClick={handleSubmit}
                            sx={{
                                backgroundColor: '#223B59',
                                color: '#fff',
                                px: 3,
                                py: 1.5,
                                fontSize: 16,
                                fontWeight: 400,
                                borderRadius: 0,
                                transition: '0.3s',
                                '&:hover': { backgroundColor: '#1A2F47' },
                            }}
                        >
                            Solicitar Servicios
                        </ButtonBase>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

const inputStyle = {
    mb: 0,
    '& .MuiOutlinedInput-root': {
        borderRadius: 0,
        '& fieldset': { borderColor: '#ccc' },
        '&:hover fieldset': { borderColor: '#223B59' },
        '&.Mui-focused fieldset': { borderColor: '#223B59' },
    },
    '& input::placeholder': { color: '#aaa', opacity: 1 },
};

export default Formulario_Contactenos;